import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { directoryServices, featuredServices, ServiceGroup } from '../data/services';
import { ServiceItemList } from './services/ServiceItemList';
import { ServiceCtaLink } from './services/ServiceCtaLink';
export function ServicesSection() {
  return <>
    <section id="services" aria-labelledby="services-title" className="section-y bg-ivory" data-id="element-296" data-mp="2l8dazn6s02zc">
      <div className="site-container" data-id="element-297" data-mp="26ka2a61cmd6u">
        <div className="grid gap-6 lg:grid-cols-12 lg:gap-10" data-id="element-298" data-mp="26j8t673w80rr">
          <div className="lg:col-span-7" data-id="element-299" data-mp="2bcaaelrkocei">
            <p className="eyebrow text-moss" data-id="element-300" data-mp="2bdd1oust4guy">Design &amp; development</p>
            <h2 id="services-title" className="section-title mt-4 max-w-[700px] text-charcoal" data-id="element-301" data-mp="1xl597f8k3c22">From private gardens to new communities.</h2>
          </div>
          <div className="max-w-[480px] lg:col-span-5 lg:self-end lg:justify-self-end" data-id="element-302" data-mp="1nlxv2ptzzddw">
            <p className="text-[16px] leading-relaxed text-charcoal/70" data-id="element-303" data-mp="1skr70dtmywby">
              Explore residential landscape design, outdoor living and land development services for your property.
            </p>
            <a href="/services" className="focus-ring group mt-3 inline-flex min-h-[44px] items-center gap-2 text-[14.5px] font-medium text-olive" data-id="element-304" data-mp="2kogiuczu9b5m">
              <span className="border-b border-olive/35 pb-0.5 transition-colors duration-150 group-hover:border-olive" data-id="element-305" data-mp="2ynfv0l65zxkw">View all services</span>
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-0.5" strokeWidth={1.5} aria-hidden="true" data-id="element-306" data-mp="26wtc1j89sk8l" />
            </a>
          </div>
        </div>

        <div className="mt-10 grid gap-12 lg:mt-14 xl:grid-cols-12 lg:gap-10" data-id="element-307" data-mp="2fov7t47e9ccj">
          {featuredServices.map((group, i) => <article key={group.id} id={group.id} aria-labelledby={`${group.id}-title`} className={`scroll-mt-6 ${i === 0 ? 'xl:col-span-7' : 'xl:col-span-5'}`} data-id="element-308" data-mp="2axc3vda5xqas" data-mpi={i}>
              <ServiceImage group={group} featured data-id="element-309" data-mp="1j77awq8c7uxy" />
              <div className="pt-6" data-id="element-310" data-mp="1j6piy5spk2vu">
                <h3 id={`${group.id}-title`} className="max-w-[620px] font-display text-[30px] font-medium leading-[1.1] text-charcoal lg:text-[34px]" data-id="element-311" data-mp="1j5ec1x3yuf0i"><GroupTitleLink group={group} data-id="element-312" data-mp="3naa8t78ptc9s" /></h3>
                <p className="mt-3 max-w-[620px] text-[16px] leading-relaxed text-charcoal/70" data-id="element-313" data-mp="3n8za3lu4mupj">{group.summary}</p>
                <ServiceClusters group={group} featured data-id="element-314" data-mp="vhg4k825edg" />
                <ServiceActions group={group} data-id="element-315" data-mp="uxyz5q8eu0h" />
              </div>
            </article>)}
        </div>

      </div>
    </section>

    <section id="property-services" aria-labelledby="property-services-title" className="section-y border-t border-olive/10 bg-[#E5E8DE]" data-id="element-316" data-mp="34c7sdgu8gnnl">
      <div className="site-container" data-id="element-317" data-mp="39a99hw83mcwf">
        <div className="grid gap-6 lg:grid-cols-12 lg:gap-10" data-id="element-318" data-mp="39ddnflbd8n0a">
          <div className="lg:col-span-7" data-id="element-319" data-mp="3ebf6w7cpeoca">
            <p className="eyebrow text-moss" data-id="element-320" data-mp="3e811srcno115">Property care</p>
            <h2 id="property-services-title" className="mt-4 max-w-[620px] font-display text-[32px] font-medium leading-[1.1] text-charcoal sm:text-[38px] lg:text-[42px]" data-id="element-321" data-mp="oka5fxu6cnz3">Keep your property looking its best.</h2>
          </div>
          <p className="max-w-[480px] text-[16px] leading-relaxed text-charcoal/70 lg:col-span-5 lg:self-end lg:justify-self-end" data-id="element-322" data-mp="2e49yv3v2innt">
            Commercial landscape maintenance, seasonal services and snow and ice management for businesses and HOA communities.
          </p>
        </div>

        <ul aria-label="Commercial and HOA property care" className="mt-10 grid gap-7 sm:grid-cols-2 lg:mt-12 lg:gap-8" data-id="element-323" data-mp="1zd146gcb6c3t">
          {directoryServices.map(group => <li key={group.id} id={group.id} className="flex scroll-mt-6" data-id="element-324" data-mp="1qbjq13igokhr">
              <article aria-labelledby={`${group.id}-title`} className="flex w-full flex-col border border-olive/10 bg-ivory" data-id="element-325" data-mp="1ld02wzs4t2nt">
                <ServiceImage group={group} data-id="element-326" data-mp="1gfgn3vfschtr" />
                <div className="flex flex-1 flex-col p-6 lg:p-8" data-id="element-327" data-mp="1ggru044j25p3">
                  <h3 id={`${group.id}-title`} className="font-display text-[28px] font-medium leading-[1.12] text-charcoal lg:text-[32px]" data-id="element-328" data-mp="3fr125lrlfrof"><GroupTitleLink group={group} data-id="element-329" data-mp="3aqd96ujt10rk" /></h3>
                  <p className="mt-3 max-w-[520px] text-[15.5px] leading-relaxed text-charcoal/70" data-id="element-330" data-mp="28g3a3vb7l2ig">{group.summary}</p>
                  <ServiceClusters group={group} data-id="element-331" data-mp="2cg3nrdqhh9og" />
                  <ServiceActions group={group} data-id="element-332" data-mp="1yh4at3cc2j84" />
                </div>
              </article>
            </li>)}
        </ul>
      </div>
    </section>
    </>;
}
function ServiceImage({
  group,
  featured = false
}: {
  group: ServiceGroup;
  featured?: boolean;
}) {
  if (!group.image) return null;
  const frame = `relative block w-full overflow-hidden bg-stone ${featured ? 'h-[260px] sm:h-[340px] lg:h-[380px]' : 'h-[190px] sm:h-[200px] xl:h-[220px]'}`;
  const img = <img src={group.image} alt={group.alt || group.title} loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover" data-id="element-333" data-mp="1fo9x0cqg4x5h" />;
  if (!group.pageHref) return <div className={frame} data-id="element-334" data-mp="15sqdyqwzdsy5">{img}</div>;
  // Image duplicates the heading link, so it is removed from tab order to avoid a repeated stop.
  return <a href={group.pageHref} tabIndex={-1} aria-hidden="true" className={frame} data-id="element-335" data-mp="r583td0ng64c">
      {img}
    </a>;
}
function GroupTitleLink({
  group
}: {
  group: ServiceGroup;
}) {
  if (!group.pageHref) return <>{group.title}</>;
  return <a href={group.pageHref} className="focus-ring transition-colors duration-150 hover:text-olive" data-id="element-336" data-mp="114p6rmoio5wm">
      {group.title}
    </a>;
}
function ServiceClusters({
  group,
  featured = false
}: {
  group: ServiceGroup;
  featured?: boolean;
}) {
  const columns = featured ? 'sm:grid-cols-2' : 'xl:grid-cols-2';
  return <div className={`mt-6 grid gap-6 border-t border-olive/20 pt-5 ${columns}`} data-id="element-337" data-mp="1628vjgiuc12t">
      {group.clusters.map(cluster => <section key={cluster.title} aria-label={`${group.title}: ${cluster.title}`} data-id="element-338" data-mp="1jvzvpyaom8lv">
          <h4 className="text-[13px] font-semibold leading-relaxed tracking-[0.04em] text-olive" data-id="element-339" data-mp="1ex5g1580h05z">{cluster.title}</h4>
          <ServiceItemList items={cluster.items} label={`${group.title} — ${cluster.title}`} data-id="element-340" data-mp="1ot8he8v1gurv" />
          {cluster.detail ? <p className="mt-2 text-[13px] leading-relaxed text-charcoal/65" data-id="element-341" data-mp="1vwq6eqvdj256">{cluster.detail}</p> : null}
        </section>)}
    </div>;
}
function ServiceActions({
  group
}: {
  group: ServiceGroup;
}) {
  if (!group.ctas?.length) return null;
  return <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-1 border-t border-charcoal/10 pt-3" data-id="element-342" data-mp="25tbclfj4qjal">
      {group.ctas.map(cta => <ServiceCtaLink key={cta.href} cta={cta} data-id="element-343" data-mp="2fkfog6dido17" />)}
    </div>;
}